export default __webpack_public_path__ + "static/chris-liverani-9cd8qOgeNIY-unsplash-52f0caff51b6afc0b097e81a061cbc4d.jpg";